import type { Icon } from '../../../src/lib/types'
export const mdiArrowUp: Icon = {
  "id": "arrow-up",
  "name": "Arrow Up",
  "path": "M13,20H11V8L5.5,13.5L4.08,12.08L12,4.16L19.92,12.08L18.5,13.5L13,8V20Z",
  "as": [
    "arrow-upward",
    "arrow-top"
  ],
  "tags": [
    "Arrow"
  ]
}
export default mdiArrowUp